import { type Store } from "../";

export function DummyComponent(props: Partial<Store>) {
  return props;
}
